function AdminPage() {
  return <h2>Willkommen im Adminbereich</h2>;
}
export default AdminPage;
